<template>
  <div class="feed_type_panel">
    <FeedTypeBtn
      :isActive="viewType === 'default'"
      @click="setView('default')"
      :text="$t('feed.type.default')"
      :img="defaultImage"
    />
    <FeedTypeBtn
      :isActive="viewType === 'short'"
      @click="setView('short')"
      :text="$t('feed.type.short')"
      :img="shortImage"
    />
  </div>

  <div class="feed_type_panel_mobail">
    <button
      ref="triggerBtn"
      class="feed_type_panel_mobail_btn"
      @click.stop="viewPanel"
    >
      {{ $t("feed.lenta") }}
      <img src="/arrow.svg" />
    </button>

    <div class="feed_type_panel_modal" v-if="isView" @click.stop>
      <FeedTypeBtn
        :isActive="viewType === 'default'"
        @click="setView('default')"
        :text="$t('feed.type.default')"
        :img="defaultImage"
      />
      <FeedTypeBtn
        :isActive="viewType === 'short'"
        @click="setView('short')"
        :text="$t('feed.type.short')"
        :img="shortImage"
      />
    </div>
  </div>
</template>

<script>
import { useThemeStore } from "@/stores/themeStore";
import { FEED_VIEW_TYPES } from "@/constants/feedViewTypes";
import MySelect from "@/UI/MySelect.vue";
import { useClickOutside } from "@/composables/useClickOutside.js";
import FeedTypeBtn from "../../UI/Button/FeedTypeBtn.vue";

export default {
  name: "FeedTypePanel",
  emits: ["update:viewType"],
  components: { MySelect, FeedTypeBtn },
  data() {
    return {
      themeStore: useThemeStore(),
      isView: false,
      removeClickOutside: false,
    };
  },
  props: {
    viewType: {
      type: String,
      required: true,
    },
  },
  methods: {
    setView(type) {
      localStorage.setItem("feed_view_type", type);
      this.$emit("update:viewType", type);
    },
    viewPanel() {
      this.isView = !this.isView;
    },
  },
  computed: {
    defaultImage() {
      return this.themeStore.isDark
        ? new URL("/defaultFeed.svg", import.meta.url).href
        : new URL("/defaultFeed-dark.svg", import.meta.url).href;
    },
    shortImage() {
      return this.themeStore.isDark
        ? new URL("/shortFeed.svg", import.meta.url).href
        : new URL("/shortFeed-dark.svg", import.meta.url).href;
    },
  },
  mounted() {
    this.removeClickOutside = useClickOutside(this.$el, (e) => {
      if (this.$refs.triggerBtn?.contains(e.target)) return;

      this.isView = false;
    });
  },
  beforeUnmount() {
    this.removeClickOutside?.();
  },
};
</script>

<style>
.feed_type_panel {
  position: absolute;
  top: 0px;
  right: -28%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.feed_type_panel_mobail {
  display: none;
  position: relative;
  margin-bottom: 10px;
  margin-left: 16px;
}

.feed_type_panel_mobail_btn {
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-color);
  text-align: center;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  border-radius: 10px;
}

.feed_type_panel_mobail_btn:hover {
  background: var(--hover);
  color: var(--text-color);
  cursor: pointer;
}

.feed_type_panel_modal {
  display: flex;
  gap: 5px;
  flex-direction: column;
  border-radius: 20px;
  padding: 8px;
  background: rgba(32, 32, 32, 1);
  position: absolute;
  z-index: 5;
  top: 38px;
  left: -10px;
}

@media (max-width: 1150px) {
  .feed_type_panel {
    display: none;
  }

  .feed_type_panel_mobail {
    display: block;
  }
}
</style>
